import {from, MonoTypeOperatorFunction, SubscribableOrPromise} from 'rxjs';
import {endWith, exhaustMap, ignoreElements} from 'rxjs/operators';

/** Like audit, but emits the first value. */
export function auditFirst<T>(
  durationSelector: (value: T) => SubscribableOrPromise<any>,
): MonoTypeOperatorFunction<T> {
  return (source$) =>
    source$.pipe(
      exhaustMap((initialValue: T) =>
        from(durationSelector(initialValue)).pipe(ignoreElements(), endWith(initialValue)),
      ),
    );
}
